// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 독립 연결 창의 연결 고르기 — 틀·제목줄·버튼은 styles/appModal.css 가 맡는다 */
.monconn-modal {
  display: flex;
  flex-direction: column;
  width: min(calc(92vw / var(--app-zoom, 1)), 440px);
  max-height: calc(80vh / var(--app-zoom, 1));
  overflow: hidden;
  background: #fff;
  color: #222;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: app-modal-rise 180ms ease-out;
}
[data-theme="dark"] .monconn-modal { background: #1e1e1e; color: #ddd; }

.monconn-body {
  padding: 12px 16px 4px;
  overflow: auto;
  min-height: 0;
}
.monconn-lead { margin: 0 0 10px; font-size: 13px; }
.monconn-note { margin: 10px 0 6px; font-size: 11.5px; color: #6b7280; }
[data-theme="dark"] .monconn-note { color: #9ca3af; }
.monconn-empty { padding: 12px 0; font-size: 12px; color: #6b7280; }

.monconn-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 4px;
  max-height: 260px;
  overflow: auto;
}
[data-theme="dark"] .monconn-list { border-color: #3a3a3a; }

.monconn-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 150ms ease;
}
.monconn-item:hover { background: #f3f4f6; }
.monconn-item-on { background: #eff6ff; }
[data-theme="dark"] .monconn-item:hover { background: #2a2a2a; }
[data-theme="dark"] .monconn-item-on { background: #1e3a5f; }
.monconn-item input { margin: 0; }
.monconn-name { flex: 1 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.monconn-tag {
  font-size: 10.5px;
  padding: 1px 6px;
  border-radius: 8px;
  background: #e0e7ff;
  color: #3730a3;
  white-space: nowrap;
}
[data-theme="dark"] .monconn-tag { background: #312e81; color: #c7d2fe; }

.monconn-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 16px 14px;
}

@media (prefers-reduced-motion: reduce) {
  .monconn-modal { animation: none; }
  .monconn-item { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/OwnConnChooser.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,wCAAwC;AAC1C;AACA,qCAAqC,mBAAmB,EAAE,WAAW,EAAE;;AAEvE;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;AACA,gBAAgB,gBAAgB,EAAE,eAAe,EAAE;AACnD,gBAAgB,kBAAkB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACvE,oCAAoC,cAAc,EAAE;AACpD,iBAAiB,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE;;AAEnE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA,oCAAoC,qBAAqB,EAAE;;AAE3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,mBAAmB,mBAAmB,EAAE;AACxC,0CAA0C,mBAAmB,EAAE;AAC/D,uCAAuC,mBAAmB,EAAE;AAC5D,sBAAsB,SAAS,EAAE;AACjC,gBAAgB,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACvG;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;;AAExE;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB,eAAe,EAAE;EAClC,gBAAgB,gBAAgB,EAAE;AACpC","sourcesContent":["/* 독립 연결 창의 연결 고르기 — 틀·제목줄·버튼은 styles/appModal.css 가 맡는다 */\r\n.monconn-modal {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: min(calc(92vw / var(--app-zoom, 1)), 440px);\r\n  max-height: calc(80vh / var(--app-zoom, 1));\r\n  overflow: hidden;\r\n  background: #fff;\r\n  color: #222;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\r\n  animation: app-modal-rise 180ms ease-out;\r\n}\r\n[data-theme=\"dark\"] .monconn-modal { background: #1e1e1e; color: #ddd; }\r\n\r\n.monconn-body {\r\n  padding: 12px 16px 4px;\r\n  overflow: auto;\r\n  min-height: 0;\r\n}\r\n.monconn-lead { margin: 0 0 10px; font-size: 13px; }\r\n.monconn-note { margin: 10px 0 6px; font-size: 11.5px; color: #6b7280; }\r\n[data-theme=\"dark\"] .monconn-note { color: #9ca3af; }\r\n.monconn-empty { padding: 12px 0; font-size: 12px; color: #6b7280; }\r\n\r\n.monconn-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  padding: 4px;\r\n  max-height: 260px;\r\n  overflow: auto;\r\n}\r\n[data-theme=\"dark\"] .monconn-list { border-color: #3a3a3a; }\r\n\r\n.monconn-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 8px;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease;\r\n}\r\n.monconn-item:hover { background: #f3f4f6; }\r\n.monconn-item-on { background: #eff6ff; }\r\n[data-theme=\"dark\"] .monconn-item:hover { background: #2a2a2a; }\r\n[data-theme=\"dark\"] .monconn-item-on { background: #1e3a5f; }\r\n.monconn-item input { margin: 0; }\r\n.monconn-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n.monconn-tag {\r\n  font-size: 10.5px;\r\n  padding: 1px 6px;\r\n  border-radius: 8px;\r\n  background: #e0e7ff;\r\n  color: #3730a3;\r\n  white-space: nowrap;\r\n}\r\n[data-theme=\"dark\"] .monconn-tag { background: #312e81; color: #c7d2fe; }\r\n\r\n.monconn-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  padding: 10px 16px 14px;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .monconn-modal { animation: none; }\r\n  .monconn-item { transition: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
